import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as CertificationActions from '../_actions/certification';
import { Certification } from '../_models/certification';

export interface CertificationState extends EntityState<Certification> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<Certification> = createEntityAdapter<Certification>();

const initialState: CertificationState = adapter.getInitialState({
  loading: false,
  error: null,
});

const certificationReducer = createReducer(
  initialState,

  on(CertificationActions.loadCertifications, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(CertificationActions.loadCertificationsSuccess, (state, { certifications }) =>
    adapter.setAll(certifications, { ...state, loading: false })
  ),

  on(CertificationActions.loadCertificationsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(CertificationActions.addCertificationSuccess, (state, { certification }) =>
    adapter.addOne(certification, state)
  ),

  on(CertificationActions.updateCertificationSuccess, (state, { certification }) =>
    adapter.upsertOne(certification, state)
  ),

  on(CertificationActions.deleteCertificationSuccess, (state, { id }) =>
    adapter.removeOne(id, state)
  ),

  on(
    CertificationActions.addCertificationFailure,
    CertificationActions.updateCertificationFailure,
    CertificationActions.deleteCertificationFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: CertificationState | undefined, action: Action) {
  return certificationReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
